// Preserve the callable API while loading its SDK only on the first invocation.
export function lazyFunctions(load) {
  let client;
  const getClient = () => client || (client = Promise.resolve().then(load).catch(error => {client = null;throw error;}));
  return {httpsCallable: (name, options) => async (...args) => (await getClient()).httpsCallable(name, options)(...args)};
}
